import axios from "axios";

const API_BASE_URL = "https://api.wielozmysly.org/wp-json/";

export const $httpService = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000
});
